import {Settings24Regular} from "@fluentui/react-icons";
import {Button} from "@fluentui/react-components";
import {useTranslation} from "react-i18next";

import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
}

export const SettingsButton = ({className, onClick}: Props) => {
    const {t} = useTranslation();
    return (

        <Button icon={<Settings24Regular className={"mr-1"}/>} onClick={onClick}
                className={"p-2 w-full flex  hover:bg-stone-100 m-2 h-12 border rounded"}>
            {t("developerSettings")}
        </Button>

    );
};
